const React = require('react');


/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`dB fillCT>path ` + (props.className || '')}
    >
      <path
        d="M14.9384 4.23442L9.33839 0.416045C8.94466 0.145077 8.47796 0 8 0C7.52204 0 7.05534 0.145077 6.66161 0.416045L1.06165 4.23442C0.733277 4.45948 0.464898 4.76139 0.279873 5.11387C0.0948484 5.46635 -0.00121254 5.85872 5.35379e-05 6.25681V13.5632C-0.00420811 14.2044 0.246106 14.8211 0.696058 15.2779C1.14601 15.7348 1.75884 15.9944 2.40004 15.9999H13.6C14.2412 15.9944 14.854 15.7348 15.3039 15.2779C15.7539 14.8211 16.0042 14.2044 15.9999 13.5632V6.25681C16.0012 5.85872 15.9052 5.46635 15.7201 5.11387C15.5351 4.76139 15.2667 4.45948 14.9384 4.23442ZM6.40001 14.4V10.4H9.59999V14.4H6.40001ZM14.4 13.5632C14.4045 13.7801 14.3228 13.99 14.1728 14.1468C14.0229 14.3037 13.8169 14.3947 13.6 14.4H11.2V9.59998C11.2 9.38781 11.1157 9.18433 10.9657 9.0343C10.8156 8.88427 10.6122 8.79999 10.4 8.79999H5.60002C5.38784 8.79999 5.18436 8.88427 5.03433 9.0343C4.88431 9.18433 4.80002 9.38781 4.80002 9.59998V14.4H2.40004C2.18311 14.3947 1.9771 14.3037 1.82715 14.1468C1.6772 13.99 1.59553 13.7801 1.60004 13.5632V6.25681C1.59895 6.11925 1.63147 5.98351 1.69476 5.86138C1.75806 5.73925 1.85022 5.63442 1.96324 5.55601L7.5632 1.73764C7.69165 1.64909 7.84398 1.60167 8 1.60167C8.15602 1.60167 8.30834 1.64909 8.4368 1.73764L14.0368 5.55601C14.1498 5.63442 14.2419 5.73925 14.3052 5.86138C14.3685 5.98351 14.401 6.11925 14.4 6.25681V13.5632Z"
      />
    </svg>
  );
};
